import { render, staticRenderFns } from "./fcsd.vue?vue&type=template&id=12fea408&scoped=true"
import script from "./fcsd.vue?vue&type=script&lang=js"
export * from "./fcsd.vue?vue&type=script&lang=js"
import style0 from "./fcsd.vue?vue&type=style&index=0&id=12fea408&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12fea408",
  null
  
)

export default component.exports